import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="slide-settings"
export default class extends Controller {
  static targets = [
    "widgetsBtn",
    "widgetsSection",
    "slideableBtn",
    "slideableSection",
    "stylingBtn",
    "stylingSection",
  ]

  toggleWidgets(event) {
    event.preventDefault()
    this.widgetsSectionTarget.classList.toggle("hidden")
    this.widgetsBtnTarget.classList.toggle("bg-white")
    this.widgetsBtnTarget.classList.toggle("bg-emerald-200")
  }

  toggleSlideable(event) {
    event.preventDefault()
    this.slideableSectionTarget.classList.toggle("hidden")
    this.slideableBtnTarget.classList.toggle("bg-white")
    this.slideableBtnTarget.classList.toggle("bg-emerald-200")
  }

  toggleStyling(event) {
    event.preventDefault()
    this.stylingSectionTarget.classList.toggle("hidden")
    this.stylingBtnTarget.classList.toggle("bg-white")
    this.stylingBtnTarget.classList.toggle("bg-emerald-200")
  }
}
